import { Skeleton, Stack } from '@/primitives';

interface Props {
  isBrief?: boolean;
}

export default function NewsCardSkeleton({ isBrief }: Props) {
  return (
    <Stack
      sx={{
        display: 'flex',
        flexDirection: isBrief ? 'row' : 'column',
        maxWidth: { xs: 'unset', md: '378px' },
      }}
    >
      <Skeleton
        sx={{
          borderRadius: isBrief ? 0 : '12px',
          height: {
            sm: isBrief ? '96px' : 'unset',
          },
          width: {
            sm: isBrief ? '96px' : '100%',
          },
          aspectRatio: isBrief
            ? '1 / 1'
            : {
                xs: '350 / 300',
                md: '336 / 260',
              },
          transform: 'none',
        }}
      />
      <Stack
        sx={{
          flex: 1,
          justifyContent: 'center',
          p: isBrief ? '0 16px !important' : '12px 0 !important',
        }}
      >
        <Skeleton
          sx={{
            width: '75%',
            lineHeight: '24px',
          }}
        />
        <Skeleton
          sx={{
            mt: isBrief ? 0 : '4px',
            width: '100%',
            lineHeight: isBrief ? '24px' : '20px',
          }}
        />
        <Skeleton
          sx={{
            mt: isBrief ? 0 : '8px',
            height: '20px',
            width: '25%',
          }}
        />
      </Stack>
    </Stack>
  );
}
